import { Box, styled } from '@mui/material';

type AdditionalInfoItemProps = {
  isUnread?: boolean;
};

export const AdditionalInfoContainer = styled(Box)(() => ({
  display: 'inline-flex',
  backgroundColor: 'transparent',
  borderRadius: '20px',
}));

export const AdditionalInfoItem = styled(Box, {
  shouldForwardProp: (prop: string) => !['isUnread'].includes(prop),
})<AdditionalInfoItemProps>(({ theme, isUnread }) => ({
  display: 'flex',
  marginRight: '8px',
  alignItems: 'center',
  position: 'relative',
  color: theme.palette.case.neutral.n600,
  svg: {
    width: '16px',
    height: '16px',
    marginRight: '4px',

    circle: {
      fill: theme.palette.case.neutral.n500,
    },
    path: {
      fill: theme.palette.case.neutral.n500,
    },
  },
  '&::before': {
    display: isUnread ? 'block' : 'none',
    position: 'absolute',
    content: '""',
    width: '8px',
    top: '-6px',
    borderRadius: '50%',
    left: '12px',
    height: '8px',
    border: '1px solid white',
    backgroundColor: theme.palette.case.red.r500,
  },
  '&:last-of-type': {
    marginRight: 0,
  },
}));
